import { render } from "./FriendList.vue?vue&type=template&id=5dd69688"
import script from "./FriendList.vue?vue&type=script&lang=js"
export * from "./FriendList.vue?vue&type=script&lang=js"
script.render = render

export default script